(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 58633:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(55558);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ graphic_Graphic; }
});

// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./src/components/graphic/Graphic10Kg.tsx
var Graphic10Kg = __webpack_require__(9640);
// EXTERNAL MODULE: ./src/components/graphic/GraphicAirpods.tsx
var GraphicAirpods = __webpack_require__(66352);
// EXTERNAL MODULE: ./src/components/graphic/GraphicAppleWatch.tsx
var GraphicAppleWatch = __webpack_require__(91917);
// EXTERNAL MODULE: ./src/components/graphic/GraphicBattery.tsx
var GraphicBattery = __webpack_require__(26523);
// EXTERNAL MODULE: ./src/components/graphic/GraphicBowling.tsx
var GraphicBowling = __webpack_require__(85564);
// EXTERNAL MODULE: ./src/components/graphic/GraphicBus.tsx
var GraphicBus = __webpack_require__(53702);
// EXTERNAL MODULE: ./src/components/graphic/GraphicCamera.tsx
var GraphicCamera = __webpack_require__(89617);
// EXTERNAL MODULE: ./src/components/graphic/GraphicCard.tsx
var GraphicCard = __webpack_require__(97348);
// EXTERNAL MODULE: ./src/components/graphic/GraphicCarrier.tsx
var GraphicCarrier = __webpack_require__(31229);
// EXTERNAL MODULE: ./src/components/graphic/GraphicCharger.tsx
var GraphicCharger = __webpack_require__(75497);
// EXTERNAL MODULE: ./src/components/graphic/GraphicCurlingIron.tsx
var GraphicCurlingIron = __webpack_require__(90668);
// EXTERNAL MODULE: ./src/components/graphic/GraphicEtc.tsx
var GraphicEtc = __webpack_require__(96658);
// EXTERNAL MODULE: ./src/components/graphic/GraphicEyeDrops.tsx
var GraphicEyeDrops = __webpack_require__(20240);
// EXTERNAL MODULE: ./src/components/graphic/GraphicFriends.tsx
var GraphicFriends = __webpack_require__(51145);
// EXTERNAL MODULE: ./src/components/graphic/GraphicGlasses.tsx
var GraphicGlasses = __webpack_require__(71687);
// EXTERNAL MODULE: ./src/components/graphic/GraphicGym.tsx
var GraphicGym = __webpack_require__(5394);
// EXTERNAL MODULE: ./src/components/graphic/GraphicHandbag.tsx
var GraphicHandbag = __webpack_require__(652);
// EXTERNAL MODULE: ./src/components/graphic/GraphicHeadband.tsx
var GraphicHeadband = __webpack_require__(4083);
// EXTERNAL MODULE: ./src/components/graphic/GraphicHeadphones.tsx
var GraphicHeadphones = __webpack_require__(83115);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-5128de1cdb/0/cache/@emotion-react-npm-11.10.0-06b9abb1e2-6d692e43ff.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(75578);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-5128de1cdb/0/cache/@emotion-react-npm-11.10.0-06b9abb1e2-6d692e43ff.zip/node_modules/@emotion/react/dist/emotion-element-cbed451f.browser.esm.js + 2 modules
var emotion_element_cbed451f_browser_esm = __webpack_require__(79214);
// EXTERNAL MODULE: ./src/components/svg/Svg.tsx
var Svg = __webpack_require__(24555);
;// CONCATENATED MODULE: ./src/components/graphic/GraphicIdCard.tsx



const GraphicIdCard = (param)=>{
    let { isAct =false , ...rest } = param;
    const theme = (0,emotion_element_cbed451f_browser_esm.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Svg/* default */.Z, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                clipPath: "url(#clip0_2627_61534)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M1.5625 6.76719C1.5625 5.85592 2.30123 5.11719 3.2125 5.11719H21.9125C22.8238 5.11719 23.5625 5.85592 23.5625 6.76719V18.8672C23.5625 19.7785 22.8238 20.5172 21.9125 20.5172H3.2125C2.30123 20.5172 1.5625 19.7785 1.5625 18.8672V6.76719Z",
                        fill: isAct ? theme.colors.primary : theme.colors.gray3
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                        cx: "7.90336",
                        cy: "12.294",
                        r: "1.72367",
                        fill: isAct ? theme.colors.secondary : theme.colors.gray2
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M11.3473 16.9371C11.3866 17.2104 11.1591 17.4355 10.8829 17.4355C10.2739 17.4355 9.16866 17.4355 7.90625 17.4355C6.64384 17.4355 5.53859 17.4355 4.92956 17.4355C4.65342 17.4355 4.42591 17.2104 4.46516 16.9371C4.70693 15.2532 6.15546 13.959 7.90625 13.959C9.65704 13.959 11.1056 15.2532 11.3473 16.9371Z",
                        fill: isAct ? theme.colors.secondary : theme.colors.gray2
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        x: "13.2734",
                        y: "11.4355",
                        width: "7.83594",
                        height: "1",
                        rx: "0.5",
                        fill: isAct ? theme.colors.secondary : theme.colors.gray2
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        x: "13.2734",
                        y: "13.5039",
                        width: "7.83594",
                        height: "1",
                        rx: "0.5",
                        fill: isAct ? theme.colors.secondary : theme.colors.gray2
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        x: "13.2734",
                        y: "15.5723",
                        width: "7.83594",
                        height: "1",
                        rx: "0.5",
                        fill: isAct ? theme.colors.secondary : theme.colors.gray2
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M1.5625 6.61719C1.5625 5.78876 2.23407 5.11719 3.0625 5.11719H22.0625C22.8909 5.11719 23.5625 5.78876 23.5625 6.61719V8.61719H1.5625V6.61719Z",
                        fill: isAct ? theme.colors.secondary : theme.colors.gray2
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                    id: "clip0_2627_61534",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: "22",
                        height: "15.4",
                        fill: "white",
                        transform: "translate(1.5625 5.11719)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var graphic_GraphicIdCard = (GraphicIdCard);

// EXTERNAL MODULE: ./src/components/graphic/GraphicKey.tsx
var GraphicKey = __webpack_require__(65786);
// EXTERNAL MODULE: ./src/components/graphic/GraphicLipbalm.tsx
var GraphicLipbalm = __webpack_require__(19915);
// EXTERNAL MODULE: ./src/components/graphic/GraphicMask.tsx
var GraphicMask = __webpack_require__(97239);
// EXTERNAL MODULE: ./src/components/graphic/GraphicMat.tsx
var GraphicMat = __webpack_require__(85218);
// EXTERNAL MODULE: ./src/components/graphic/GraphicPassport.tsx
var GraphicPassport = __webpack_require__(11177);
// EXTERNAL MODULE: ./src/components/graphic/GraphicPC.tsx
var GraphicPC = __webpack_require__(37395);
// EXTERNAL MODULE: ./src/components/graphic/GraphicPerfume.tsx
var GraphicPerfume = __webpack_require__(55161);
// EXTERNAL MODULE: ./src/components/graphic/GraphicPill.tsx
var GraphicPill = __webpack_require__(66370);
// EXTERNAL MODULE: ./src/components/graphic/GraphicPlane.tsx
var GraphicPlane = __webpack_require__(5181);
// EXTERNAL MODULE: ./src/components/graphic/GraphicPouch.tsx
var GraphicPouch = __webpack_require__(94761);
// EXTERNAL MODULE: ./src/components/graphic/GraphicProtein.tsx
var GraphicProtein = __webpack_require__(83204);
// EXTERNAL MODULE: ./src/components/graphic/GraphicRoaming.tsx
var GraphicRoaming = __webpack_require__(32276);
// EXTERNAL MODULE: ./src/components/graphic/GraphicRun.tsx
var GraphicRun = __webpack_require__(22700);
// EXTERNAL MODULE: ./src/components/graphic/GraphicSchool.tsx
var GraphicSchool = __webpack_require__(64625);
;// CONCATENATED MODULE: ./src/components/graphic/GraphicShake.tsx



const GraphicShake = (param)=>{
    let { isAct =false , ...rest } = param;
    const theme = (0,emotion_element_cbed451f_browser_esm.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Svg/* default */.Z, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                clipPath: "url(#clip0_2604_61141)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M16.6066 1.77815L11.0724 19.8935C11.0321 20.0256 11.1064 20.1653 11.2385 20.2057L12.2703 20.5209C12.4024 20.5612 12.5421 20.4869 12.5825 20.3548L18.1167 2.23947C18.157 2.10743 18.0827 1.96768 17.9506 1.92734L16.9188 1.6121C16.7867 1.57176 16.647 1.64611 16.6066 1.77815Z",
                        fill: isAct ? theme.colors.primary : theme.colors.gray3
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M16.4879 24.0957H10.211C9.72725 24.0957 9.31287 23.7495 9.2269 23.2734L8.80232 20.9227L7.52658 13.8596L6.71094 9.34375H19.2438L18.6699 13.8596L17.7721 20.9227L17.4799 23.2218C17.4164 23.7213 16.9914 24.0957 16.4879 24.0957Z",
                        fill: isAct ? theme.colors.primary : theme.colors.gray3
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M18.6296 7.21289H7.02662C6.6505 7.21289 6.30618 7.42395 6.1355 7.75912L5.69826 8.61779C5.52887 8.95044 5.77052 9.34467 6.14382 9.34467H19.5124C19.8857 9.34467 20.1274 8.95044 19.958 8.61779L19.5207 7.75912C19.3501 7.42395 19.0058 7.21289 18.6296 7.21289Z",
                        fill: isAct ? theme.colors.primary : theme.colors.gray3
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M18.6667 13.8594H7.52344L8.79917 20.9225H17.769L18.6667 13.8594Z",
                        fill: isAct ? theme.colors.primary : theme.colors.gray3
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                    id: "clip0_2604_61141",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: "15",
                        height: "22.5566",
                        fill: "white",
                        transform: "translate(5.32812 1.53906)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var graphic_GraphicShake = (GraphicShake);

// EXTERNAL MODULE: ./src/components/graphic/GraphicSocket.tsx
var GraphicSocket = __webpack_require__(12791);
// EXTERNAL MODULE: ./src/components/graphic/GraphicSportSwear.tsx
var GraphicSportSwear = __webpack_require__(32185);
// EXTERNAL MODULE: ./src/components/graphic/GraphicStrap.tsx
var GraphicStrap = __webpack_require__(59732);
// EXTERNAL MODULE: ./src/components/graphic/GraphicSunglasses.tsx
var GraphicSunglasses = __webpack_require__(3006);
// EXTERNAL MODULE: ./src/components/graphic/GraphicSwim.tsx
var GraphicSwim = __webpack_require__(22312);
// EXTERNAL MODULE: ./src/components/graphic/GraphicTeeth.tsx
var GraphicTeeth = __webpack_require__(56881);
// EXTERNAL MODULE: ./src/components/graphic/GraphicTissue.tsx
var GraphicTissue = __webpack_require__(4348);
// EXTERNAL MODULE: ./src/components/graphic/GraphicToescoks.tsx
var GraphicToescoks = __webpack_require__(27043);
// EXTERNAL MODULE: ./src/components/graphic/GraphicToiletries.tsx
var GraphicToiletries = __webpack_require__(20816);
// EXTERNAL MODULE: ./src/components/graphic/GraphicTowel.tsx
var GraphicTowel = __webpack_require__(21809);
// EXTERNAL MODULE: ./src/components/graphic/GraphicTube.tsx
var GraphicTube = __webpack_require__(52783);
// EXTERNAL MODULE: ./src/components/graphic/GraphicTumbler.tsx
var GraphicTumbler = __webpack_require__(98557);
// EXTERNAL MODULE: ./src/components/graphic/GraphicUnderwear.tsx
var GraphicUnderwear = __webpack_require__(32844);
// EXTERNAL MODULE: ./src/components/graphic/GraphicWallet.tsx
var GraphicWallet = __webpack_require__(4778);
// EXTERNAL MODULE: ./src/components/graphic/GraphicWork.tsx
var GraphicWork = __webpack_require__(44657);
;// CONCATENATED MODULE: ./src/components/graphic/Graphic.tsx



















































const graphicElement = (type)=>{
    switch(type){
        case "BOWLING":
            return GraphicBowling/* default */.Z;
        case "BUS":
            return GraphicBus/* default */.Z;
        case "CAMERA":
            return GraphicCamera/* default */.Z;
        case "ETC":
            return GraphicEtc/* default */.Z;
        case "FRIENDS":
            return GraphicFriends/* default */.Z;
        case "GYM":
            return GraphicGym/* default */.Z;
        case "PLANE":
            return GraphicPlane/* default */.Z;
        case "RUN":
            return GraphicRun/* default */.Z;
        case "SCHOOL":
            return GraphicSchool/* default */.Z;
        case "SWIM":
            return GraphicSwim/* default */.Z;
        case "TUBE":
            return GraphicTube/* default */.Z;
        case "WORK":
            return GraphicWork/* default */.Z;
        case "10KG":
            return Graphic10Kg/* default */.Z;
        case "CARD":
            return GraphicCard/* default */.Z;
        case "PC":
            return GraphicPC/* default */.Z;
        case "AIRPODS":
            return GraphicAirpods/* default */.Z;
        case "HANDBAG":
            return GraphicHandbag/* default */.Z;
        case "LIPBALM":
            return GraphicLipbalm/* default */.Z;
        case "APPLEWATCH":
            return GraphicAppleWatch/* default */.Z;
        case "BATTERY":
            return GraphicBattery/* default */.Z;
        case "CARRIER":
            return GraphicCarrier/* default */.Z;
        case "CHARGER":
            return GraphicCharger/* default */.Z;
        case "CURLINGIRON":
            return GraphicCurlingIron/* default */.Z;
        case "EYEDROPS":
            return GraphicEyeDrops/* default */.Z;
        case "GLASSES":
            return GraphicGlasses/* default */.Z;
        case "HEADBAND":
            return GraphicHeadband/* default */.Z;
        case "HEADPHONES":
            return GraphicHeadphones/* default */.Z;
        case "IDCARD":
            return graphic_GraphicIdCard;
        case "KEY":
            return GraphicKey/* default */.Z;
        case "MASK":
            return GraphicMask/* default */.Z;
        case "MAT":
            return GraphicMat/* default */.Z;
        case "PASSPORT":
            return GraphicPassport/* default */.Z;
        case "PERFUME":
            return GraphicPerfume/* default */.Z;
        case "PILL":
            return GraphicPill/* default */.Z;
        case "POUCH":
            return GraphicPouch/* default */.Z;
        case "PROTEIN":
            return GraphicProtein/* default */.Z;
        case "ROAMING":
            return GraphicRoaming/* default */.Z;
        case "SHAKE":
            return graphic_GraphicShake;
        case "SOCKET":
            return GraphicSocket/* default */.Z;
        case "SPORTSWEAR":
            return GraphicSportSwear/* default */.Z;
        case "STRAP":
            return GraphicStrap/* default */.Z;
        case "SUNGLASSES":
            return GraphicSunglasses/* default */.Z;
        case "TEETH":
            return GraphicTeeth/* default */.Z;
        case "TISSUE":
            return GraphicTissue/* default */.Z;
        case "TOESCOKS":
            return GraphicToescoks/* default */.Z;
        case "TOILETRIES":
            return GraphicToiletries/* default */.Z;
        case "TOWEL":
            return GraphicTowel/* default */.Z;
        case "TUMBLER":
            return GraphicTumbler/* default */.Z;
        case "UNDERWEAR":
            return GraphicUnderwear/* default */.Z;
        case "WALLET":
            return GraphicWallet/* default */.Z;
        default:
            return GraphicEtc/* default */.Z;
    }
};
const Graphic = (param)=>{
    let { type , isAct , ...rest } = param;
    return /*#__PURE__*/ (0,react.createElement)(graphicElement(type), {
        isAct,
        ...rest
    });
};
/* harmony default export */ var graphic_Graphic = (Graphic);


/***/ }),

/***/ 17652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75578);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27297);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7978);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40102);
/* harmony import */ var _icon_IconHome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85099);
/* harmony import */ var _icon_IconSearch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66356);






const ROUTE_MATCH_ELEMENT = [
    {
        route: "/",
        matchElement: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_IconHome__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            isAct: true
        }),
        nonMatchElement: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_IconHome__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
    },
    {
        route: "/template",
        matchElement: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_IconSearch__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            isAct: true
        }),
        nonMatchElement: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_IconSearch__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
    }
];
/**
 * 
 * @example
 * 
 * ```
 * HomePage.getLayout = function getLayout(page: ReactElement) {
    return (
      <>
        {page}
        <BottomNavigation />
      </>
    );
  };
  ```
 */ const BottomNavigation = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Wrapper, {
                children: ROUTE_MATCH_ELEMENT.map((param)=>/*#__PURE__*/ {
                    let { route , matchElement , nonMatchElement  } = param;
                    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Anchor, {
                        href: route,
                        children: router.asPath === route ? matchElement : nonMatchElement
                    }, route);
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ScrollableDiv, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BottomNavigation);
const HEIGHT = "56px";
const Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("section", {
    target: "egppwp20"
})({
    width: "100%",
    height: HEIGHT,
    position: "fixed",
    bottom: 0,
    left: 0,
    display: "flex"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.white,
        borderTop: "1px solid ".concat(theme.colors.gray1)
    };
});
const Anchor = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
    target: "egppwp21"
})({
    width: "50%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const ScrollableDiv = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div", {
    target: "egppwp22"
})({
    height: HEIGHT,
    appearance: "none"
});


/***/ }),

/***/ 58720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75578);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77182);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27297);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40102);
/* harmony import */ var _icon_IconAlarm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74677);
/* harmony import */ var _icon_IconMenu__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21817);
/* harmony import */ var _hooks_common_useToggle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70193);







const Drawer = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>__webpack_require__.e(/* import() */ 142).then(__webpack_require__.bind(__webpack_require__, 3142)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3142)
            ]
    }
});
const DefaultAppBar = ()=>{
    const [isDrawerShowing, _, toggleDrawerShowing] = (0,_hooks_common_useToggle__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(false);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Wrapper, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(ButtonWrapper, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledLink, {
                            href: "/notice",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_icon_IconAlarm__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Button, {
                            onClick: toggleDrawerShowing,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_icon_IconMenu__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Drawer, {
                isShowing: isDrawerShowing,
                setToClose: toggleDrawerShowing
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultAppBar);
const Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("section", {
    target: "ej887y50"
})({
    position: "sticky",
    top: "0",
    left: "0",
    width: "100%",
    height: "48px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.gray1
    };
});
const ButtonWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div", {
    target: "ej887y51"
})({
    position: "absolute",
    top: "0",
    right: "-12px",
    height: "100%",
    display: "flex"
});
const Button = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button", {
    target: "ej887y52"
})({
    all: "unset",
    cursor: "pointer",
    width: "48px",
    height: "48px",
    textAlign: "center"
});
const StyledLink = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    target: "ej887y53"
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "48px",
    height: "48px"
});


/***/ }),

/***/ 63195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ USER_CATEGORY_QUERY_KEY; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97759);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70359);


const getCategories = ()=>(0,_lib_api__WEBPACK_IMPORTED_MODULE_0__/* .get */ .U2)("/category/user");
const USER_CATEGORY_QUERY_KEY = "user_category";
const useGetUserCategories = ()=>{
    var ref;
    const query = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)({
        queryKey: [
            USER_CATEGORY_QUERY_KEY
        ],
        queryFn: getCategories
    });
    return {
        ...query,
        data: (ref = query.data) === null || ref === void 0 ? void 0 : ref.result
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetUserCategories);


/***/ }),

/***/ 66476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97759);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72208);
/* harmony import */ var _useGetUserTemplate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80460);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70359);
/* harmony import */ var _store_route_home_currentCategory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28693);
/* harmony import */ var _store_route_home_currentUserTemplate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85289);






const useCardItemMutation = ()=>{
    const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__.useQueryClient)();
    const currentCategory = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilValue */ .sJ)(_store_route_home_currentCategory__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
    const currentTemplate = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilValue */ .sJ)(_store_route_home_currentUserTemplate__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
    const invalidateCurrentUserTemplate = ()=>{
        queryClient.invalidateQueries([
            _useGetUserTemplate__WEBPACK_IMPORTED_MODULE_1__/* .USER_TEMPLATE_QUERY_KEY */ .Q,
            currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id
        ]);
    };
    const createCardItemMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__.useMutation)((param)=>{
        let { itemName , important  } = param;
        if (!currentCategory) throw new Error("");
        if (!currentTemplate) throw new Error("");
        const requestData = {
            itemName,
            important,
            categoryId: currentCategory.id,
            templateId: currentTemplate.id
        };
        return (0,_lib_api__WEBPACK_IMPORTED_MODULE_2__/* .post */ .v_)("/template/item", requestData);
    }, {
        onSuccess: ()=>{
            invalidateCurrentUserTemplate();
        }
    });
    const deleteCardItemMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__.useMutation)((param)=>{
        let { itemId  } = param;
        if (!currentTemplate) throw new Error("");
        const requestData = {
            itemId,
            templateId: currentTemplate.id
        };
        return (0,_lib_api__WEBPACK_IMPORTED_MODULE_2__/* .del */ .IV)("/template/item", {
            data: requestData
        });
    }, {
        onSuccess: ()=>{
            invalidateCurrentUserTemplate();
        }
    });
    return {
        createCardItemMutation,
        deleteCardItemMutation
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCardItemMutation);


/***/ }),

/***/ 80460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ USER_TEMPLATE_QUERY_KEY; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97759);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72208);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70359);
/* harmony import */ var _store_route_home_currentCategory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28693);




const getUserTemplate = (categoryId)=>(0,_lib_api__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2)("/template/user?category=".concat(categoryId));
const USER_TEMPLATE_QUERY_KEY = "user_template";
const useGetUserTemplate = ()=>{
    var ref;
    const currentCategory = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilValue */ .sJ)(_store_route_home_currentCategory__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
    const query = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)({
        queryKey: [
            USER_TEMPLATE_QUERY_KEY,
            currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id
        ],
        queryFn: ()=>getUserTemplate(currentCategory.id),
        enabled: Boolean(currentCategory)
    });
    return {
        ...query,
        data: (ref = query.data) === null || ref === void 0 ? void 0 : ref.result
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetUserTemplate);


/***/ }),

/***/ 55558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-5128de1cdb/0/cache/@emotion-react-npm-11.10.0-06b9abb1e2-6d692e43ff.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(75578);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/recoil-virtual-459f56a2cd/0/cache/recoil-npm-0.7.5-b0fe76743a-19b410cca6.zip/node_modules/recoil/es/index.js
var es = __webpack_require__(72208);
// EXTERNAL MODULE: ./src/components/carousel/Carousel.tsx + 1 modules
var Carousel = __webpack_require__(18391);
// EXTERNAL MODULE: ./src/components/loading/FixedSpinner.tsx
var FixedSpinner = __webpack_require__(90680);
// EXTERNAL MODULE: ./src/components/loading/LoadingHandler.tsx
var LoadingHandler = __webpack_require__(61912);
// EXTERNAL MODULE: ./src/components/navigation/BottomNavigation.tsx
var BottomNavigation = __webpack_require__(17652);
// EXTERNAL MODULE: ./src/components/navigation/DefaultAppBar.tsx
var DefaultAppBar = __webpack_require__(58720);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-4e7940a640/0/cache/next-npm-13.0.2-b39abd22d0-f6fea2ee34.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(77182);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-styled-virtual-2aaf7f2de3/0/cache/@emotion-styled-npm-11.10.0-ee745c48ee-f2a3e9798f.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(40102);
// EXTERNAL MODULE: ./src/components/alarm/bottom-sheet/AlarmBottomSheet.tsx + 12 modules
var AlarmBottomSheet = __webpack_require__(75824);
// EXTERNAL MODULE: ./src/components/button/LabelButton.tsx
var LabelButton = __webpack_require__(81919);
// EXTERNAL MODULE: ./src/components/icon/IconAdd.tsx
var IconAdd = __webpack_require__(52976);
// EXTERNAL MODULE: ./src/components/icon/IconAlarmAdd.tsx
var IconAlarmAdd = __webpack_require__(59459);
// EXTERNAL MODULE: ./src/components/icon/IconSetting.tsx
var IconSetting = __webpack_require__(84282);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-5128de1cdb/0/cache/@emotion-react-npm-11.10.0-06b9abb1e2-6d692e43ff.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(32746);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-5128de1cdb/0/cache/@emotion-react-npm-11.10.0-06b9abb1e2-6d692e43ff.zip/node_modules/@emotion/react/dist/emotion-element-cbed451f.browser.esm.js + 2 modules
var emotion_element_cbed451f_browser_esm = __webpack_require__(79214);
// EXTERNAL MODULE: ./.yarn/__virtual__/framer-motion-virtual-12ae7d66a8/0/cache/framer-motion-npm-7.5.1-450b8d268a-7785459f34.zip/node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 2 modules
var AnimatePresence = __webpack_require__(6875);
// EXTERNAL MODULE: ./.yarn/__virtual__/framer-motion-virtual-12ae7d66a8/0/cache/framer-motion-npm-7.5.1-450b8d268a-7785459f34.zip/node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(66618);
// EXTERNAL MODULE: ./src/constants/motions.ts
var motions = __webpack_require__(19370);
;// CONCATENATED MODULE: ./src/components/route-home/IconCardItemCheck.tsx




const IconCardItemCheck = (param)=>{
    let { isChecked , isImportant  } = param;
    const theme = (0,emotion_element_cbed451f_browser_esm.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
        mode: "wait",
        children: isChecked ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(motion_minimal.m.svg, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            initial: "initial",
            animate: "animate",
            exit: "exit",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.rect, {
                    x: "2",
                    y: "2",
                    width: "20",
                    height: "20",
                    rx: "10",
                    fill: "white",
                    variants: opacityVariants,
                    custom: 1
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.path, {
                    d: "M8 12.1277L10.6861 14.8139L16 9.5",
                    stroke: "#212121",
                    strokeWidth: "2.91971",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    variants: drawVariants
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.path, {
                    d: "M10.6859 14.8139L15.9997 9.5",
                    stroke: "#FF6C3E",
                    strokeWidth: "2.91971",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    variants: drawVariants
                })
            ]
        }, "checked") : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(motion_minimal.m.svg, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            initial: "initial",
            animate: "animate",
            exit: "exit",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.path, {
                    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                    fill: "white",
                    variants: opacityVariants,
                    custom: isImportant ? 0.5 : 1
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.path, {
                    d: "M10.7 10.7002L13.3861 13.3863",
                    stroke: isImportant ? theme.colors.secondary : theme.colors.gray1,
                    strokeWidth: "2.91971",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    variants: drawVariants
                })
            ]
        }, "unchecked")
    });
};
/* harmony default export */ var route_home_IconCardItemCheck = (IconCardItemCheck);
const drawVariants = {
    initial: {
        pathLength: 0,
        opacity: 0,
        transition: {
            duration: 0.3,
            ease: motions/* defaultEasing */.gc
        }
    },
    animate: {
        pathLength: 1,
        opacity: 1,
        transition: {
            duration: 0.3,
            ease: motions/* defaultEasing */.gc
        }
    },
    exit: {
        pathLength: 0,
        opacity: 0,
        transition: {
            duration: 0.3,
            ease: motions/* defaultEasing */.gc
        }
    }
};
const opacityVariants = {
    initial: {
        opacity: 0,
        transition: {
            duration: 0.3,
            ease: motions/* defaultEasing */.gc
        }
    },
    animate: (op)=>({
            opacity: op,
            transition: {
                duration: 0.3,
                ease: motions/* defaultEasing */.gc
            }
        }),
    exit: {
        opacity: 0,
        transition: {
            duration: 0.3,
            ease: motions/* defaultEasing */.gc
        }
    }
};

// EXTERNAL MODULE: ./src/hooks/common/useToggle.ts
var useToggle = __webpack_require__(70193);
;// CONCATENATED MODULE: ./src/components/route-home/CardItem.tsx







const CardItemSettingBottomSheet = dynamic_default()(()=>__webpack_require__.e(/* import() */ 935).then(__webpack_require__.bind(__webpack_require__, 92935)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(92935)
            ]
    }
});
const CardItem = (param)=>{
    let { name , take , important , itemId  } = param;
    const id = (0,react.useId)();
    // TODO: API 대응
    const [isCurrentChecked, _, toggleCurrentChecked] = (0,useToggle/* default */.Z)(take);
    const [isCardItemSettingShowing, __, toggleIsCardItemSettingShowing] = (0,useToggle/* default */.Z)(false);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
                isChecked: isCurrentChecked,
                isImportant: important,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HidedInput, {
                        id: id,
                        type: "checkbox",
                        checked: isCurrentChecked,
                        onChange: toggleCurrentChecked
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconLabel, {
                        htmlFor: id,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_IconCardItemCheck, {
                            isChecked: isCurrentChecked,
                            isImportant: important
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NameButton, {
                        type: "button",
                        onClick: toggleIsCardItemSettingShowing,
                        isChecked: isCurrentChecked,
                        isImportant: important,
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardItemSettingBottomSheet, {
                itemId: itemId,
                name: name,
                important: important,
                setToClose: toggleIsCardItemSettingShowing,
                isShowing: isCardItemSettingShowing
            })
        ]
    });
};
/* harmony default export */ var route_home_CardItem = (CardItem);
const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1pidbgs0"
})({
    position: "relative",
    display: "flex",
    gap: "8px",
    width: "fit-content",
    maxWidth: "100%",
    paddingTop: "7px",
    paddingBottom: "7px",
    paddingLeft: "8px",
    paddingRight: "10px",
    borderRadius: "8px",
    transition: "background-color 0.3s"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.gray1
    };
}, (param)=>{
    let { isImportant , theme  } = param;
    return isImportant && importantWrapperCss(theme);
}, (param)=>{
    let { isImportant , isChecked  } = param;
    return isImportant && isChecked && checkedWhenImportantWrapperCss;
});
const importantWrapperCss = (theme)=>/*#__PURE__*/ (0,emotion_react_browser_esm.css)({
        backgroundColor: theme.colors.secondary
    });
const checkedWhenImportantWrapperCss = /*#__PURE__*/ (0,emotion_react_browser_esm.css)({
    backgroundColor: "#FFD3C5"
});
const HidedInput = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("input", {
    target: "e1pidbgs1"
})({
    position: "absolute",
    clipPath: "polygon(0 0, 0 0, 0 0)"
});
const IconLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("label", {
    target: "e1pidbgs2"
})({
    cursor: "pointer",
    width: "24px",
    height: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const NameButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e1pidbgs3"
})({
    all: "unset",
    cursor: "pointer",
    display: "inline-block",
    maxWidth: "100%",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    transition: "color 0.3s"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.button2
    };
}, (param)=>{
    let { isChecked , theme  } = param;
    return isChecked && checkedButtonCss(theme);
}, (param)=>{
    let { isImportant , isChecked  } = param;
    return isImportant && isChecked && checkedWhenImportantButtonCss;
});
const checkedButtonCss = (theme)=>/*#__PURE__*/ (0,emotion_react_browser_esm.css)({
        color: theme.colors.gray3
    });
const checkedWhenImportantButtonCss = /*#__PURE__*/ (0,emotion_react_browser_esm.css)({
    color: "#C7A79C"
});

;// CONCATENATED MODULE: ./src/components/route-home/Card.tsx










const ListSettingBottomSheet = dynamic_default()(()=>__webpack_require__.e(/* import() */ 220).then(__webpack_require__.bind(__webpack_require__, 49220)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(49220)
            ]
    }
});
const CardItemAppendBottomSheet = dynamic_default()(()=>__webpack_require__.e(/* import() */ 762).then(__webpack_require__.bind(__webpack_require__, 11762)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(11762)
            ]
    }
});
const Card = (param)=>{
    let { id , templateName , alarmCycle , items , pin  } = param;
    const [isListSettingShowing, _, toggleListSettingShowing] = (0,useToggle/* default */.Z)(false);
    const [isCardItemAppendShowing, __, toggleCardItemAppendShowing] = (0,useToggle/* default */.Z)(false);
    const [isAlarmSettingShowing, ___, toggleAlarmSettingShowing] = (0,useToggle/* default */.Z)(false);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TitleHeading, {
                        children: templateName
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AlarmCycleSpan, {
                        children: alarmCycle
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemWrapper, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LabelButton/* default */.Z, {
                                size: "large",
                                withIcon: true,
                                onClick: toggleCardItemAppendShowing,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconAdd/* default */.Z, {}),
                                    "추가하기"
                                ]
                            }),
                            items.map((item)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_CardItem, {
                                    itemId: item.id,
                                    take: item.take,
                                    important: item.important,
                                    name: item.name
                                }, item.id))
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomButtonWrapper, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomButton, {
                                type: "button",
                                onClick: toggleAlarmSettingShowing,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconAlarmAdd/* default */.Z, {}),
                                    " 알림"
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomButton, {
                                type: "button",
                                onClick: toggleListSettingShowing,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconSetting/* default */.Z, {}),
                                    " 설정"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListSettingBottomSheet, {
                id: id,
                templateName: templateName,
                pin: pin,
                setToClose: toggleListSettingShowing,
                isShowing: isListSettingShowing
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardItemAppendBottomSheet, {
                setToClose: toggleCardItemAppendShowing,
                isShowing: isCardItemAppendShowing
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AlarmBottomSheet/* default */.Z, {
                setToClose: toggleAlarmSettingShowing,
                isShowing: isAlarmSettingShowing
            })
        ]
    });
};
/* harmony default export */ var route_home_Card = (Card);
const Card_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1s1xh9y0"
})({
    position: "relative",
    width: "100%",
    minHeight: "410px",
    height: "100%",
    // NOTE: 100vh - DefaultAppBar - Category - Indicator - Recommend - BottomNavigation
    maxHeight: "calc(100vh - 48px - 56px - 24px - 114px - 56px)",
    padding: "20px",
    // NOTE: bottom button wrapper height
    paddingBottom: "calc(48px)",
    borderRadius: "16px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.white
    };
});
const TitleHeading = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "e1s1xh9y1"
})({
    marginBottom: "4px"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.title2,
        color: theme.colors.gray6
    };
});
const AlarmCycleSpan = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e1s1xh9y2"
})({
    display: "inline-block",
    marginBottom: "24px"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.caption2,
        color: theme.colors.gray4
    };
});
// const PinButton = styled.button({
//   all: 'unset',
//   cursor: 'pointer',
//   position: 'absolute',
//   top: '11px',
//   right: '8px',
//   width: '48px',
//   height: '48px',
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
// });
const ItemWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1s1xh9y3"
})({
    flexGrow: "1",
    overflow: "scroll",
    display: "flex",
    flexDirection: "column",
    gap: "8px"
});
const BottomButtonWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1s1xh9y4"
})({
    position: "absolute",
    bottom: "0",
    left: "0",
    width: "100%",
    height: "48px",
    display: "flex"
}, (param)=>{
    let { theme  } = param;
    return {
        borderTop: "1px solid ".concat(theme.colors.gray1)
    };
});
const BottomButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e1s1xh9y5"
})({
    all: "unset",
    cursor: "pointer",
    width: "50%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.caption2,
        color: theme.colors.gray5
    };
});

// EXTERNAL MODULE: ./src/components/button/IconButton.tsx
var IconButton = __webpack_require__(97124);
// EXTERNAL MODULE: ./src/components/chip/Chip.tsx
var Chip = __webpack_require__(15110);
// EXTERNAL MODULE: ./src/components/graphic/Graphic.tsx + 2 modules
var Graphic = __webpack_require__(58255);
// EXTERNAL MODULE: ./src/components/icon/IconOverflow.tsx
var IconOverflow = __webpack_require__(8070);
// EXTERNAL MODULE: ./src/hooks/api/category/useGetUserCategories.ts
var useGetUserCategories = __webpack_require__(63195);
// EXTERNAL MODULE: ./src/store/route-home/currentCategory.ts
var route_home_currentCategory = __webpack_require__(28693);
;// CONCATENATED MODULE: ./src/components/route-home/category/CategorySection.tsx












const CategorySettingBottomSheet = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(406), __webpack_require__.e(618)]).then(__webpack_require__.bind(__webpack_require__, 63618)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(63618)
            ]
    }
});
const CategorySection = ()=>{
    const [isCategorySettingShowing, setCategorySettingShowing, toggleCategorySettingShowing] = (0,useToggle/* default */.Z)(false);
    const { data , currentCategory , setCurrentCategory  } = useCategories();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChipWrapper, {
                        children: data === null || data === void 0 ? void 0 : data.map((eachCategory)=>{
                            const isCurrentCategory = eachCategory.id === (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id);
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Chip/* default */.Z, {
                                label: eachCategory.name,
                                color: isCurrentCategory ? "black" : "default",
                                onClick: ()=>setCurrentCategory(eachCategory),
                                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Graphic/* default */.Z, {
                                    type: eachCategory.emoji,
                                    isAct: isCurrentCategory
                                })
                            }, eachCategory.id);
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverflowWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* default */.Z, {
                            onClick: toggleCategorySettingShowing,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconOverflow/* default */.Z, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategorySettingBottomSheet, {
                isShowing: isCategorySettingShowing,
                setToClose: ()=>setCategorySettingShowing(false)
            })
        ]
    });
};
/* harmony default export */ var category_CategorySection = (CategorySection);
const Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "elqjhm30"
})({
    width: "100%",
    height: "56px",
    display: "flex",
    alignItems: "center",
    marginBottom: "8px"
});
const ChipWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "elqjhm31"
})({
    position: "relative",
    width: "calc(100% - 40px)",
    height: "100%",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    overflowX: "auto",
    "& > *": {
        flexShrink: "0"
    }
});
const OverflowWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "elqjhm32"
})({
    position: "relative"
}, (param)=>{
    let { theme  } = param;
    return {
        "&::after": {
            content: '""',
            position: "absolute",
            top: "0",
            right: "100%",
            width: "24px",
            height: "100%",
            background: "linear-gradient(to right, rgba(0, 0, 0, 0), ".concat(theme.colors.gray1, " 90%)")
        }
    };
});
const useCategories = ()=>{
    const query = (0,useGetUserCategories/* default */.Z)();
    const [currentCategory, setCurrentCategory] = (0,es/* useRecoilState */.FV)(route_home_currentCategory/* default */.Z);
    (0,react.useEffect)(()=>{
        if (!query.data) return;
        if (currentCategory !== null) return;
        setCurrentCategory(query.data[0]);
    }, [
        query.data
    ]);
    return {
        ...query,
        currentCategory,
        setCurrentCategory
    };
};

// EXTERNAL MODULE: ./src/components/svg/Svg.tsx
var Svg = __webpack_require__(24555);
;// CONCATENATED MODULE: ./src/components/graphic/GraphicEmptyCard.tsx


const GraphicEmptyCard = (param)=>{
    let { width =222 , height =216 , viewBox ="0 0 222 216" , ...rest } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Svg/* default */.Z, {
        width: width,
        height: height,
        viewBox: viewBox,
        ...rest,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            opacity: "0.2",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                    opacity: "0.6",
                    cx: "31.7893",
                    cy: "188.975",
                    rx: "28.2424",
                    ry: "3.05324",
                    fill: "#C7C7D0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                    opacity: "0.8",
                    cx: "124.408",
                    cy: "207.454",
                    rx: "79.2911",
                    ry: "8.5443",
                    fill: "#C7C7D0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    opacity: "0.6",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M28.9562 137.661C35.8482 136.869 40.7933 130.64 40.0013 123.748C39.2094 116.856 32.9804 111.911 26.0884 112.703C19.1964 113.495 14.2514 119.724 15.0433 126.616C15.8352 133.508 22.0643 138.453 28.9562 137.661ZM27.8659 128.209C29.5366 128.017 30.7355 126.506 30.5435 124.836C30.3515 123.165 28.8414 121.966 27.1706 122.158C25.4999 122.35 24.301 123.86 24.493 125.531C24.685 127.202 26.1951 128.401 27.8659 128.209Z",
                            fill: "#9090A0"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                            x: "6.69531",
                            y: "118.371",
                            width: "11.0843",
                            height: "36.6221",
                            rx: "3.10356",
                            transform: "rotate(-22.1155 6.69531 118.371)",
                            fill: "#464656"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                            x: "1.4375",
                            y: "128.184",
                            width: "52.909",
                            height: "52.5284",
                            rx: "7.61281",
                            transform: "rotate(-6.55488 1.4375 128.184)",
                            fill: "#C7C7D0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M135.28 43.4072C144.662 44.5021 153.156 37.7841 154.251 28.4021C155.346 19.02 148.628 10.5268 139.245 9.43181C129.863 8.33685 121.37 15.0549 120.275 24.4369C119.18 33.8189 125.898 42.3122 135.28 43.4072ZM136.78 30.5353C139.055 30.8007 141.114 29.1721 141.379 26.8977C141.644 24.6232 140.016 22.5643 137.741 22.2988C135.467 22.0334 133.408 23.662 133.143 25.9364C132.877 28.2108 134.506 30.2698 136.78 30.5353Z",
                    fill: "#9090A0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: "97.2344",
                    y: "8.88672",
                    width: "101.447",
                    height: "141.498",
                    rx: "11.2379",
                    transform: "rotate(12.9128 97.2344 8.88672)",
                    fill: "#464656"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M120.75 24.7969L132.59 26.1787",
                    stroke: "#464656",
                    strokeWidth: "1.516",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M141.859 27.2578L153.699 28.6396",
                    stroke: "#464656",
                    strokeWidth: "1.516",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M45.1492 113.881C46.7625 100.058 59.2764 90.1594 73.0998 91.7727L76.1426 92.1278C91.0502 93.8676 101.725 107.363 99.985 122.271L96.261 154.179C95.7428 158.62 91.7229 161.8 87.2824 161.281L52.7725 157.254C45.8608 156.447 40.9116 150.19 41.7183 143.278L45.1492 113.881Z",
                    fill: "#9090A0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M207.844 132.873C209.458 119.05 199.56 106.536 185.736 104.923L182.693 104.568C167.786 102.828 154.29 113.502 152.55 128.41L148.826 160.319C148.308 164.759 151.488 168.779 155.928 169.297L190.438 173.325C197.35 174.131 203.607 169.182 204.414 162.271L207.844 132.873Z",
                    fill: "#9090A0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M66.6191 82.1402C70.6523 47.5816 101.937 22.836 136.496 26.8692L138.999 27.1613C173.557 31.1946 198.303 62.4794 194.27 97.0379L185.637 171.008C184.435 181.302 175.116 188.673 164.823 187.472L74.4496 176.925C64.1557 175.723 56.7848 166.404 57.9862 156.111L66.6191 82.1402Z",
                    fill: "#C7C7D0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M168.125 173.612L171.664 143.289C174.729 117.025 155.922 93.2482 129.658 90.183C103.393 87.1177 79.6167 105.924 76.5514 132.189L73.0126 162.511C72.0631 170.647 77.8885 178.012 86.024 178.961L151.675 186.623C159.81 187.573 167.175 181.747 168.125 173.612Z",
                    fill: "#E9E9EE"
                })
            ]
        })
    });
};
/* harmony default export */ var graphic_GraphicEmptyCard = (GraphicEmptyCard);

;// CONCATENATED MODULE: ./src/components/route-home/EmptyCard.tsx







const ListAppendBottomSheet = dynamic_default()(()=>__webpack_require__.e(/* import() */ 947).then(__webpack_require__.bind(__webpack_require__, 56947)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(56947)
            ]
    }
});
const EmptyCard = ()=>{
    const [isShowingListAppend, _, toggleIsShowingListAppend] = (0,useToggle/* default */.Z)(false);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EmptyCard_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GraphicWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(graphic_GraphicEmptyCard, {})
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LabelButton/* default */.Z, {
                            withIcon: true,
                            onClick: toggleIsShowingListAppend,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconAdd/* default */.Z, {}),
                                " 추가하기"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListAppendBottomSheet, {
                isShowing: isShowingListAppend,
                setToClose: toggleIsShowingListAppend
            })
        ]
    });
};
/* harmony default export */ var route_home_EmptyCard = (EmptyCard);
const EmptyCard_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qiog10"
})({
    width: "100%",
    minHeight: "410px",
    height: "100%",
    borderRadius: "16px",
    overflow: "hidden",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column"
});
const GraphicWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qiog11"
})({
    width: "100%",
    height: "100%",
    flexGrow: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const ButtonWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qiog12"
})({
    width: "100%",
    height: "48px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}, (param)=>{
    let { theme  } = param;
    return {
        borderTop: "1px solid ".concat(theme.colors.gray1)
    };
});

// EXTERNAL MODULE: ./.yarn/__virtual__/framer-motion-virtual-12ae7d66a8/0/cache/framer-motion-npm-7.5.1-450b8d268a-7785459f34.zip/node_modules/framer-motion/dist/es/animation/use-animation.mjs + 1 modules
var use_animation = __webpack_require__(33210);
// EXTERNAL MODULE: ./src/components/icon/IconCancelSmall.tsx
var IconCancelSmall = __webpack_require__(87329);
;// CONCATENATED MODULE: ./src/components/tag/Tag.tsx




const Tag = /*#__PURE__*/ (0,react.forwardRef)(function Tag(param, forwardedRef) {
    let { value , onClick , onClickCancel , ...rest } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button, {
        type: "button",
        ref: forwardedRef,
        isShowingIconCancel: Boolean(onClickCancel),
        onClick: onClick,
        ...rest,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: value
            }),
            onClickCancel && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconCancelSmall/* default */.Z, {
                onClick: onClickCancel
            })
        ]
    });
});
const Button = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "ekjb3rl0"
})({
    all: "unset",
    cursor: "pointer",
    maxWidth: "100%",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    borderRadius: "8px"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.button2,
        backgroundColor: theme.colors.gray1,
        color: theme.colors.gray6
    };
}, (param)=>{
    let { isShowingIconCancel  } = param;
    return isShowingIconCancel ? {
        paddingTop: "7px",
        paddingBottom: "7px",
        paddingLeft: "8px",
        paddingRight: "4px"
    } : {
        padding: "7px 8px"
    };
});
/* harmony default export */ var tag_Tag = (Tag);

// EXTERNAL MODULE: ./.yarn/__virtual__/@tanstack-react-query-virtual-adb565d675/0/cache/@tanstack-react-query-npm-4.1.0-7940d0afc5-aaa340cbec.zip/node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(97759);
// EXTERNAL MODULE: ./src/lib/api.ts
var api = __webpack_require__(70359);
;// CONCATENATED MODULE: ./src/hooks/api/recommend-item/useGetRecommendItem.tsx




const HOME_RECOMMEND_ITEM_QUERY_KEY = "home_recommend_item";
const getRecommendItem = (categoryId)=>(0,api/* get */.U2)("/recommend/items?category=".concat(categoryId));
const useGetRecommendItem = ()=>{
    var ref;
    const currentCategory = (0,es/* useRecoilValue */.sJ)(route_home_currentCategory/* default */.Z);
    const query = (0,index_production.useQuery)({
        queryKey: [
            HOME_RECOMMEND_ITEM_QUERY_KEY,
            currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id
        ],
        queryFn: ()=>getRecommendItem(currentCategory.id),
        enabled: Boolean(currentCategory)
    });
    return {
        ...query,
        data: (ref = query.data) === null || ref === void 0 ? void 0 : ref.result
    };
};
/* harmony default export */ var recommend_item_useGetRecommendItem = (useGetRecommendItem);

// EXTERNAL MODULE: ./src/hooks/api/template/useCardItemMutation.ts
var useCardItemMutation = __webpack_require__(66476);
// EXTERNAL MODULE: ./src/hooks/life-cycle/useDidUpdate.ts
var useDidUpdate = __webpack_require__(84061);
;// CONCATENATED MODULE: ./src/components/route-home/RecommendSection.tsx











const HIDE_BOTTOM_POS = 84;
const RecommendSection = ()=>{
    const { onDragStart , onDragEnd , onClickToggleButton , animationControls  } = useSectionVisible();
    const { items , isLoading , appendToCard , removeFromItems  } = useRecommendItem();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
        mode: "wait",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RecommendSection_Wrapper, {
            animate: animationControls,
            drag: "y",
            dragElastic: 0,
            dragMomentum: false,
            dragConstraints: {
                top: 0,
                bottom: HIDE_BOTTOM_POS
            },
            onDragStart: onDragStart,
            onDragEnd: onDragEnd,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DragHandlerButton, {
                    type: "button",
                    onClick: onClickToggleButton,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DragHandlerSpan, {})
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LoadingHandler/* default */.Z, {
                    isLoading: isLoading,
                    fallback: undefined,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionText, {
                            children: "이런 건 어때요?"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecommendSection_ItemWrapper, {
                            children: items.map((item)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTag, {
                                    value: item.name,
                                    onClick: appendToCard(item),
                                    onClickCancel: removeFromItems(item.id)
                                }, item.id))
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var route_home_RecommendSection = (RecommendSection);
const RecommendSection_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(motion_minimal.m.section, {
    target: "eedb1e0"
})({
    position: "fixed",
    bottom: "54px",
    left: "0",
    width: "100%",
    height: "104px",
    borderRadius: "20px 20px 0 0",
    display: "flex",
    flexDirection: "column"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.white,
        padding: theme.size.layoutPadding,
        paddingTop: "28px",
        paddingBottom: "20px"
    };
});
const DragHandlerButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "eedb1e1"
})({
    all: "unset",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const DragHandlerSpan = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "eedb1e2"
})({
    width: "2.125rem",
    height: "4px",
    borderRadius: "10px"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.gray2
    };
});
const SuggestionText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "eedb1e3"
})({
    marginBottom: "8px"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.caption2,
        color: theme.colors.gray4
    };
});
const RecommendSection_ItemWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eedb1e4"
})({
    display: "flex",
    flexShrink: 0,
    gap: "8px",
    marginBottom: "22px",
    flexWrap: "nowrap",
    overflowX: "scroll",
    overflowY: "hidden"
});
const StyledTag = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(tag_Tag, {
    target: "eedb1e5"
})({
    flex: "0 0 auto",
    height: "38px"
});
const useSectionVisible = ()=>{
    const animationControls = (0,use_animation/* useAnimationControls */.E)();
    const [isVisible, setIsVisible, toggleVisible] = (0,useToggle/* default */.Z)(true);
    const isDragRef = (0,react.useRef)(false);
    const startAnimationDependsOnIsVisble = ()=>{
        if (isVisible) {
            animationControls.start(visibleMotion);
        } else {
            animationControls.start(hideMotion);
        }
    };
    const onDragStart = ()=>{
        isDragRef.current = true;
    };
    const onDragEnd = (_, info)=>{
        const shouldVisible = info.velocity.y < -50 && info.offset.y < 0;
        setIsVisible(shouldVisible);
        startAnimationDependsOnIsVisble();
        setTimeout(()=>{
            isDragRef.current = false;
        }, 0);
    };
    const onClickToggleButton = ()=>{
        if (isDragRef.current) return;
        toggleVisible();
    };
    (0,useDidUpdate/* default */.Z)(()=>{
        startAnimationDependsOnIsVisble();
    }, [
        isVisible
    ]);
    return {
        onDragStart,
        onDragEnd,
        onClickToggleButton,
        animationControls
    };
};
const visibleMotion = {
    y: 0,
    transition: {
        duration: 0.5,
        ease: motions/* defaultEasing */.gc
    }
};
const hideMotion = {
    y: HIDE_BOTTOM_POS,
    transition: {
        duration: 0.5,
        ease: motions/* defaultEasing */.gc
    }
};
const useRecommendItem = ()=>{
    const { data , isLoading  } = recommend_item_useGetRecommendItem();
    const [items, setItems] = (0,react.useState)([]);
    const { createCardItemMutation  } = (0,useCardItemMutation/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (!data) return;
        setItems(data.items.map((item, index)=>({
                id: index,
                name: item
            })));
    }, [
        data
    ]);
    const removeFromItems = (itemId)=>(e)=>{
            e.stopPropagation();
            setItems((prev)=>prev.filter((item)=>item.id !== itemId));
        };
    const appendToCard = (item)=>()=>{
            createCardItemMutation.mutate({
                itemName: item.name,
                important: false
            });
            removeFromItems(item.id);
        };
    return {
        items,
        isLoading,
        appendToCard,
        removeFromItems
    };
};

// EXTERNAL MODULE: ./src/hooks/api/template/useGetUserTemplate.ts
var useGetUserTemplate = __webpack_require__(80460);
// EXTERNAL MODULE: ./src/store/route-home/currentUserTemplate.ts
var currentUserTemplate = __webpack_require__(85289);
;// CONCATENATED MODULE: ./src/hooks/route-home/useCurrentUserTemplate.ts





const useCurrentUserTemplate = ()=>{
    const currentCategory = (0,es/* useRecoilValue */.sJ)(route_home_currentCategory/* default */.Z);
    const setCurrentUserTemplate = (0,es/* useSetRecoilState */.Zl)(currentUserTemplate/* default */.Z);
    const queryClient = (0,index_production.useQueryClient)();
    const userTemplates = queryClient.getQueryData([
        useGetUserTemplate/* USER_TEMPLATE_QUERY_KEY */.Q,
        currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id
    ]);
    const onCarouselIndexChange = (index)=>{
        if (!userTemplates) return;
        var _index;
        setCurrentUserTemplate((_index = userTemplates.result[index]) !== null && _index !== void 0 ? _index : null);
    };
    return {
        onCarouselIndexChange
    };
};
/* harmony default export */ var route_home_useCurrentUserTemplate = (useCurrentUserTemplate);

// EXTERNAL MODULE: ./src/store/push-notification/fcmToken.ts
var push_notification_fcmToken = __webpack_require__(60045);
;// CONCATENATED MODULE: ./src/pages/index.page.tsx
















const HomePage = ()=>{
    const [carouselWrapper, setCarouselWrapper] = (0,react.useState)(null);
    const { data , isLoading  } = (0,useGetUserTemplate/* default */.Z)();
    const { onCarouselIndexChange  } = route_home_useCurrentUserTemplate();
    const fcmToken = (0,es/* useRecoilValue */.sJ)(push_notification_fcmToken/* default */.Z);
    const sendFcmToken = ()=>{
        (0,api/* get */.U2)("/alarm?token=".concat(fcmToken));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(category_CategorySection, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                type: "button",
                onClick: ()=>{
                    sendFcmToken();
                },
                children: "FCM 토큰 전송 \uD83E\uDDDA‍♀️"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LoadingHandler/* default */.Z, {
                fallback: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FixedSpinner/* default */.Z, {}),
                isLoading: isLoading,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Carousel/* default.Wrapper */.Z.Wrapper, {
                        ref: setCarouselWrapper,
                        children: [
                            data === null || data === void 0 ? void 0 : data.map((userTemplate)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Carousel/* default.Item */.Z.Item, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_Card, {
                                        id: userTemplate.id,
                                        templateName: userTemplate.templateName,
                                        alarmCycle: "매주 화 오후 6:00",
                                        items: userTemplate.items,
                                        userToken: userTemplate.userToken,
                                        categoryId: userTemplate.categoryId,
                                        pin: userTemplate.pin
                                    })
                                }, userTemplate.id)),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Carousel/* default.Item */.Z.Item, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_EmptyCard, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Carousel/* default.Indicator */.Z.Indicator, {
                        carouselWrapper: carouselWrapper,
                        onIndexChange: onCarouselIndexChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_RecommendSection, {})
        ]
    });
};
HomePage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultAppBar/* default */.Z, {}),
            page,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BottomNavigation/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var index_page = (HomePage);


/***/ }),

/***/ 28693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72208);

const currentCategoryState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "currentCategoryState",
    default: null
});
/* harmony default export */ __webpack_exports__["Z"] = (currentCategoryState);


/***/ }),

/***/ 85289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72208);

const currentUserTemplateState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "currentUserTemplateState",
    default: null
});
/* harmony default export */ __webpack_exports__["Z"] = (currentUserTemplateState);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [945,175,629,276,774,888,179], function() { return __webpack_exec__(58633); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);